export default __webpack_public_path__ + "static/media/image.zipro-international-pvt-ltd-.1466d0e2.png";